// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"1ccf9897","587":"6c35429e","719":"f9f4ccb6","965":"4a854132"}[chunkId] + ".chunk.js";
};